
import {getWithDrawals} from '../api/getWithdrawals';
import {setWithdrawalsAction} from '../action';

const setWithdrawals = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithDrawals(params);
        
            if (data.status === 'success') {
                dispatch(setWithdrawalsAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setWithdrawals
}